export enum ConfigManagerProperties {
  buildVersion = 'buildVersion',
}
